'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var resizeObserver = require('@juggle/resize-observer');

function useResize(element) {
  const [width, setWidth] = react.useState();
  const [height, setHeight] = react.useState();
  react.useEffect(() => {
    if (!element) return;
    const obs = new resizeObserver.ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      setWidth(entry.borderBoxSize[0].inlineSize);
      setHeight(entry.borderBoxSize[0].blockSize);
    });
    obs.observe(element);
    return () => {
      obs.disconnect();
    };
  }, [element]);
  return {
    width,
    height
  };
}

exports.default = useResize;
